import React from "react";
import ExternalScripts from "../../../common/ExternalScripts";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

// Swiper core styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useNavigate } from "react-router-dom";

 const array=["images/resource/shop3-1.jpg",
"images/resource/shop3-5.jpg",
"images/resource/shop3-2.jpg",
"images/resource/shop3-3.jpg",
"images/resource/shop3-4.jpg",
"images/resource/shop3-6.jpg",
"images/resource/shop3-7.jpg",
"images/resource/shop3-8.jpg"
]

const getRandomImages = (arr, count) => {
  return arr
    .sort(() => Math.random() - 0.5)   // shuffle array
    .slice(0, count);                  // pick first 3
};


const BannerSectionsecond = ({loading,error,inventories,selectedType,setSelectedType,types}) => {

    <ExternalScripts/>

if(error){
  console.log("Error Occured:"+error)
}
if(loading){
  console.log("Loading...")
}

const getRandomLogo = (type) => {
  const logos = [<svg
                  width={34}
                  height={34}
                  viewBox="0 0 34 34"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_47_1028)">
                    <path
                      d="M32.8913 21.4348H31.7826V15.8914C31.7826 14.0573 30.2905 12.5653 28.4565 12.5653H24.8209L23.3616 8.1873C22.908 6.82704 21.6399 5.91309 20.2061 5.91309C20.0334 5.91309 8.04731 5.91309 7.76083 5.91309C6.31543 5.91309 5.08313 6.84005 4.62546 8.13046H3.32609C1.49208 8.13046 0 9.62254 0 11.4565V15.8914C0 17.7254 1.49208 19.2174 3.32609 19.2174H4.43481V21.4348H3.32609C2.71382 21.4348 2.21737 21.9312 2.21737 22.5435C2.21737 23.1559 2.71376 23.6523 3.32609 23.6523C4.36442 23.6523 5.6104 23.6523 6.65218 23.6523C6.65218 26.0976 8.64164 28.0871 11.087 28.0871C13.5323 28.0871 15.5218 26.0976 15.5218 23.6523H20.6957C20.6957 26.0976 22.6852 28.0871 25.1305 28.0871C27.5759 28.0871 29.5653 26.0976 29.5653 23.6523C30.6074 23.6523 31.8538 23.6523 32.8914 23.6523C33.5037 23.6523 34.0001 23.1559 34.0001 22.5435C34.0001 21.9312 33.5036 21.4348 32.8913 21.4348ZM4.43481 17H3.32609C2.71475 17 2.21737 16.5026 2.21737 15.8913V11.4565C2.21737 10.8451 2.71475 10.3478 3.32609 10.3478H4.43481C4.43481 11.0542 4.43481 16.315 4.43481 17ZM15.5217 8.13046H17.3696H20.2061C20.6841 8.13046 21.1068 8.43513 21.2579 8.88848L22.4834 12.5652H15.5217V8.13046ZM6.65218 9.23911C6.65218 8.62777 7.14956 8.13039 7.7609 8.13039H13.3044V12.5652H6.65218V9.23911ZM11.087 25.8696C9.86432 25.8696 8.86962 24.8749 8.86962 23.6522C8.86962 22.4295 9.86432 21.4348 11.087 21.4348C12.3097 21.4348 13.3044 22.4295 13.3044 23.6522C13.3044 24.8749 12.3097 25.8696 11.087 25.8696ZM25.1304 25.8696C23.9078 25.8696 22.9131 24.8749 22.9131 23.6522C22.9131 22.4295 23.9078 21.4348 25.1304 21.4348C26.3531 21.4348 27.3478 22.4295 27.3478 23.6522C27.3478 24.8749 26.3531 25.8696 25.1304 25.8696ZM29.5652 21.4348H28.9686C28.2005 20.1106 26.7683 19.2174 25.1304 19.2174C23.4926 19.2174 22.0604 20.1106 21.2923 21.4348H14.9251C14.1571 20.1106 12.7248 19.2174 11.087 19.2174C9.44914 19.2174 8.01689 20.1106 7.24884 21.4348H6.65225V18.1087V14.7826C8.46022 14.7826 27.2694 14.7826 28.4566 14.7826C29.0679 14.7826 29.5653 15.28 29.5653 15.8914V21.4348H29.5652Z"
                      fill="#050B20"
                    />
                    <path
                      d="M18.8478 17H16.6304C16.0182 17 15.5217 17.4964 15.5217 18.1087C15.5217 18.721 16.0181 19.2174 16.6304 19.2174H18.8478C19.4601 19.2174 19.9565 18.7211 19.9565 18.1087C19.9565 17.4964 19.4602 17 18.8478 17Z"
                      fill="#050B20"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_47_1028">
                      <rect width={34} height={34} fill="white" />
                    </clipPath>
                  </defs>
                </svg>,<svg
                  width={34}
                  height={34}
                  viewBox="0 0 34 34"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M30.759 15.5873L24.8898 14.6086C24.5466 14.0512 23.8644 13.0429 22.8725 12.0327C20.8927 10.0164 18.6133 8.95068 16.2806 8.95068H6.7225C5.16993 8.95068 3.73044 9.79012 2.96577 11.1414L0.331898 15.7962C0.327648 15.8037 0.324461 15.8115 0.32041 15.8191C0.116676 16.1837 0 16.6033 0 17.0499V21.9548C0 22.5049 0.445984 22.9508 0.996094 22.9508H4.18632C4.65455 24.176 5.848 25.0494 7.24339 25.0494C8.63879 25.0494 9.83224 24.176 10.3005 22.9508H22.672C23.1402 24.176 24.3336 25.0494 25.729 25.0494C27.1244 25.0494 28.3178 24.176 28.786 22.9508H33.0039C33.554 22.9508 34 22.5049 34 21.9548V19.3178C34 17.4492 32.6077 15.8482 30.759 15.5873ZM22.3976 14.5182H15.222V10.9429H16.2806C19.104 10.9429 21.2363 13.0302 22.3976 14.5182ZM8.57371 10.9429H13.2299V14.5182H8.57371V10.9429ZM4.69964 12.1225C5.08811 11.436 5.80012 10.9953 6.58152 10.9477V14.5182H3.34402L4.69964 12.1225ZM7.24339 23.0572C6.53929 23.0572 5.96647 22.494 5.96647 21.8016C5.96647 21.1093 6.53929 20.546 7.24339 20.546C7.9475 20.546 8.52032 21.1093 8.52032 21.8016C8.52032 22.494 7.9475 23.0572 7.24339 23.0572ZM25.729 23.0572C25.0248 23.0572 24.452 22.494 24.452 21.8016C24.452 21.1093 25.0249 20.546 25.729 20.546C26.4331 20.546 27.0059 21.1093 27.0059 21.8016C27.0059 22.494 26.4331 23.0572 25.729 23.0572ZM28.8857 20.9586C28.5111 19.5753 27.2381 18.5538 25.729 18.5538C24.2198 18.5538 22.9469 19.5753 22.5721 20.9586H10.4001C10.0255 19.5753 8.75254 18.5538 7.24339 18.5538C5.73425 18.5538 4.4613 19.5753 4.08657 20.9586H1.99219V17.0499C1.99219 16.7524 2.23417 16.5104 2.53167 16.5104H24.183L30.4445 17.5546C30.4541 17.5562 30.4637 17.5577 30.4734 17.559C30.6428 17.5822 30.804 17.6295 30.9541 17.6967C30.5374 17.8159 30.232 18.1988 30.232 18.6538C30.232 19.2039 30.678 19.6499 31.2281 19.6499H32.0078V20.9587H28.8857V20.9586Z"
                    fill="white"
                  />
                </svg>,<svg
                  width={34}
                  height={34}
                  viewBox="0 0 34 34"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M26.5625 13.8124H25.3194C25.1795 13.8133 25.0409 13.7865 24.9115 13.7336C24.782 13.6807 24.6643 13.6028 24.565 13.5043L21.7387 10.6781C21.0418 9.9811 20.2132 9.42962 19.3012 9.0557C18.3891 8.68177 17.4119 8.49286 16.4263 8.49995H7.4375C6.02854 8.49995 4.67728 9.05966 3.681 10.0559C2.68471 11.0522 2.125 12.4035 2.125 13.8124V19.1249C2.125 19.9703 2.46083 20.7811 3.0586 21.3789C3.65637 21.9766 4.46712 22.3124 5.3125 22.3124C5.3125 23.2987 5.7043 24.2446 6.4017 24.942C7.0991 25.6394 8.04498 26.0312 9.03125 26.0312C10.0175 26.0312 10.9634 25.6394 11.6608 24.942C12.3582 24.2446 12.75 23.2987 12.75 22.3124H20.2938C20.4112 23.2014 20.8478 24.0174 21.5221 24.6085C22.1965 25.1996 23.0626 25.5255 23.9594 25.5255C24.8561 25.5255 25.7223 25.1996 26.3966 24.6085C27.071 24.0174 27.5075 23.2014 27.625 22.3124H28.6875C29.5329 22.3124 30.3436 21.9766 30.9414 21.3789C31.5392 20.7811 31.875 19.9703 31.875 19.1249C31.875 17.716 31.3153 16.3647 30.319 15.3684C29.3227 14.3722 27.9715 13.8124 26.5625 13.8124ZM16.4794 10.6249C17.1775 10.6237 17.869 10.7601 18.5144 11.0262C19.1598 11.2924 19.7464 11.6832 20.2406 12.1762L21.8769 13.8124H8.755C8.55699 13.8138 8.36253 13.7598 8.19357 13.6566C8.0246 13.5533 7.88785 13.4049 7.79875 13.2281L6.56625 10.7631C6.84804 10.6734 7.14178 10.6268 7.4375 10.6249H16.4794ZM4.25 19.1249V13.8124C4.25058 13.1672 4.44694 12.5374 4.81313 12.0062L5.87563 14.1312C6.13626 14.6733 6.54495 15.1305 7.05446 15.4501C7.56398 15.7698 8.15353 15.9387 8.755 15.9374H14.875V20.1874H12.3781C12.0797 19.5519 11.6064 19.0144 11.0137 18.638C10.421 18.2615 9.7334 18.0616 9.03125 18.0616C8.3291 18.0616 7.64146 18.2615 7.04876 18.638C6.45607 19.0144 5.98282 19.5519 5.68437 20.1874H5.3125C5.03071 20.1874 4.76046 20.0755 4.5612 19.8763C4.36194 19.677 4.25 19.4067 4.25 19.1249ZM9.03125 23.3749C8.71604 23.3749 8.4079 23.2815 8.14581 23.1064C7.88372 22.9312 7.67944 22.6823 7.55882 22.3911C7.43819 22.0999 7.40663 21.7794 7.46812 21.4703C7.52962 21.1611 7.68141 20.8771 7.9043 20.6542C8.12719 20.4314 8.41117 20.2796 8.72032 20.2181C9.02948 20.1566 9.34993 20.1881 9.64115 20.3088C9.93237 20.4294 10.1813 20.6337 10.3564 20.8958C10.5315 21.1578 10.625 21.466 10.625 21.7812C10.625 22.2039 10.4571 22.6093 10.1582 22.9081C9.85932 23.207 9.45394 23.3749 9.03125 23.3749ZM23.9062 23.3749C23.591 23.3749 23.2829 23.2815 23.0208 23.1064C22.7587 22.9312 22.5544 22.6823 22.4338 22.3911C22.3132 22.0999 22.2816 21.7794 22.3431 21.4703C22.4046 21.1611 22.5564 20.8771 22.7793 20.6542C23.0022 20.4314 23.2862 20.2796 23.5953 20.2181C23.9045 20.1566 24.2249 20.1881 24.5162 20.3088C24.8074 20.4294 25.0563 20.6337 25.2314 20.8958C25.4065 21.1578 25.5 21.466 25.5 21.7812C25.5 22.2039 25.3321 22.6093 25.0332 22.9081C24.7343 23.207 24.3289 23.3749 23.9062 23.3749ZM28.6875 20.1874H27.2531C26.9547 19.5519 26.4814 19.0144 25.8887 18.638C25.296 18.2615 24.6084 18.0616 23.9062 18.0616C23.2041 18.0616 22.5165 18.2615 21.9238 18.638C21.3311 19.0144 20.8578 19.5519 20.5594 20.1874H17V15.9374H26.5625C27.0081 15.9398 27.4482 16.0356 27.8545 16.2186C28.2608 16.4017 28.6242 16.6678 28.9212 16.9999H28.6875C28.4057 16.9999 28.1355 17.1119 27.9362 17.3111C27.7369 17.5104 27.625 17.7807 27.625 18.0624C27.625 18.3442 27.7369 18.6145 27.9362 18.8138C28.1355 19.013 28.4057 19.1249 28.6875 19.1249H29.75C29.75 19.4067 29.6381 19.677 29.4388 19.8763C29.2395 20.0755 28.9693 20.1874 28.6875 20.1874Z"
                    fill="white"
                  />
                </svg>,
                <svg
                  width={34}
                  height={34}
                  viewBox="0 0 34 34"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_47_1051)">
                    <path
                      d="M29.1539 12.9591H26.4432C25.5374 11.6291 24.3322 10.5173 22.9281 9.72437C21.3558 8.83644 19.5704 8.36719 17.765 8.36719H17C16.4451 8.36719 15.9953 8.81699 15.9953 9.37184V12.9591H4.8461C2.39815 12.9591 0.369644 14.784 0.0461731 17.1445C0.0425415 17.1673 0.0394287 17.1901 0.0373535 17.2135C0.0137482 17.4078 0 17.6049 0 17.8054V21.6469C0 22.2017 0.449799 22.6515 1.00465 22.6515H4.51978C4.96672 24.3781 6.5379 25.6567 8.40221 25.6567C10.2665 25.6567 11.8377 24.3781 12.2846 22.6515H21.7154C22.1626 24.3781 23.7335 25.6567 25.5978 25.6567C27.4621 25.6567 29.033 24.3781 29.4802 22.6515H32.9953C33.5502 22.6515 34 22.2017 34 21.6469V17.8054C34 15.1331 31.826 12.9591 29.1539 12.9591ZM18.0047 10.3801C20.2251 10.4437 22.3312 11.3907 23.8588 12.9591H18.0047V10.3801ZM2.00931 18.304H3.56104C4.11589 18.304 4.56569 17.8542 4.56569 17.2993C4.56569 16.7445 4.11589 16.2947 3.56104 16.2947H2.44691C2.94989 15.4986 3.83704 14.9686 4.8461 14.9686H15.9953V20.6422H12.2846C11.8374 18.9157 10.2665 17.6368 8.40221 17.6368C6.5379 17.6368 4.96698 18.9157 4.51978 20.6422H2.00931V18.304ZM10.4027 21.6469C10.4027 22.7501 9.50543 23.6474 8.40221 23.6474C7.29898 23.6474 6.40172 22.7501 6.40172 21.6469C6.40172 20.5437 7.29898 19.6464 8.40221 19.6464C9.50543 19.6464 10.4027 20.5437 10.4027 21.6469ZM27.5983 21.6469C27.5983 22.7501 26.701 23.6474 25.5978 23.6474C24.4946 23.6474 23.5973 22.7501 23.5973 21.6469C23.5973 20.5437 24.4946 19.6464 25.5978 19.6464C26.701 19.6464 27.5983 20.5437 27.5983 21.6469ZM29.4802 20.6422C29.0333 18.9157 27.4621 17.6368 25.5978 17.6368C23.7335 17.6368 22.1623 18.9157 21.7154 20.6422H18.0047V14.9686H29.1539C30.1451 14.9686 31.019 15.4802 31.5264 16.2527H29.9715C29.4167 16.2527 28.9669 16.7025 28.9669 17.2573C28.9669 17.8122 29.4167 18.2622 29.9715 18.2622H31.9907V20.6422H29.4802Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_47_1051">
                      <rect width={34} height={34} fill="white" />
                    </clipPath>
                  </defs>
                </svg>,<svg
                  width={34}
                  height={34}
                  viewBox="0 0 34 34"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M30.5394 15.7463L26.3033 14.0526L23.8414 8.30769C23.3378 7.13362 22.1882 6.375 20.9111 6.375H11.1658C9.75056 6.375 8.48938 7.32594 8.1005 8.687L6.63637 13.8125H4.25C3.07806 13.8125 2.125 14.7656 2.125 15.9375V22.3125C2.125 23.4844 3.07806 24.4375 4.25 24.4375H6.52588C7.00081 26.265 8.65088 27.625 10.625 27.625C12.5991 27.625 14.2492 26.265 14.7241 24.4375H19.2759C19.7508 26.265 21.4009 27.625 23.375 27.625C25.3491 27.625 26.9992 26.265 27.4741 24.4375H29.75C30.9219 24.4375 31.875 23.4844 31.875 22.3125V17.7193C31.875 16.8449 31.3512 16.0703 30.5394 15.7463ZM10.625 25.5C9.45306 25.5 8.5 24.5469 8.5 23.375C8.5 22.2031 9.45306 21.25 10.625 21.25C11.7969 21.25 12.75 22.2031 12.75 23.375C12.75 24.5469 11.7969 25.5 10.625 25.5ZM23.375 25.5C22.2031 25.5 21.25 24.5469 21.25 23.375C21.25 22.2031 22.2031 21.25 23.375 21.25C24.5469 21.25 25.5 22.2031 25.5 23.375C25.5 24.5469 24.5469 25.5 23.375 25.5ZM29.75 22.3125H27.4741C26.9992 20.485 25.3491 19.125 23.375 19.125C21.4009 19.125 19.7508 20.485 19.2759 22.3125H14.7241C14.2492 20.485 12.5991 19.125 10.625 19.125C8.65088 19.125 7.00081 20.485 6.52588 22.3125H4.25V15.9375H7.4375C7.91138 15.9375 8.32894 15.623 8.45856 15.1672L10.1426 9.27137C10.2733 8.81662 10.693 8.5 11.1658 8.5H20.9111C21.3361 8.5 21.7196 8.75287 21.8875 9.14387L24.5225 15.2936C24.633 15.5529 24.8423 15.7569 25.1037 15.8621L29.75 17.7193V22.3125Z"
                    fill="white"
                  />
                  <path
                    d="M15.3476 18.9465C14.86 18.6214 14.7282 17.9616 15.0533 17.4728L16.0765 15.9375H14.8748C14.4828 15.9375 14.1226 15.7218 13.9377 15.3765C13.7528 15.0312 13.773 14.6115 13.9908 14.2864L16.1158 11.0989C16.441 10.6102 17.1008 10.4784 17.5895 10.8046C18.0772 11.1297 18.209 11.7895 17.8838 12.2783L16.8606 13.8125H18.0623C18.4544 13.8125 18.8146 14.0282 18.9995 14.3735C19.1843 14.7188 19.1641 15.1385 18.9463 15.4637L16.8213 18.6512C16.4951 19.141 15.8343 19.2717 15.3476 18.9465Z"
                    fill="white"
                  />
                </svg>]


    return logos[type=="SUV"?0:type==="Sedan"?1:type==="Hatchback"?2:type==="Coupe"?3:type==="Hybrid"?4:5 ];
}

const message = encodeURIComponent(
  "Hello! I am interested in this car. Please share more details."
);

const navigate = useNavigate()
const handleOpen = (obj) => {
  localStorage.setItem("Inventory-Detail",JSON.stringify({id:obj._id}))
  navigate("/InventoryDetail")
}
  return (
    <div>
      <div>
        <section className="boxcar-banner-section-v1 banner-style-three" style={{ position: 'relative', overflow: 'hidden' }}>
           <div style={{
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 0,
    pointerEvents: 'none', // So clicks pass through
    overflow: 'hidden'
  }}>
  
 <video
    autoPlay
    muted
    loop
    playsInline
    style={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      transform: 'translate(-50%, -50%)',
      zIndex: 0
    }}
  >
    <source src="./video/11490-230853032_medium.mp4" type="video/mp4" />
    Your browser does not support the video tag.
  </video>

  </div>
          <div className="banner-content-three">
            <div className="boxcar-container">
              <div className="banner-content">
                <span className="wow fadeInUp">
  Buy quality used and new cars with confidence
</span>
<h2 className="wow fadeInUp" data-wow-delay="100ms">
  Drive Home the Right Car
</h2>
                  {/* <a style={{ marginBottom:"20px", position:"relative", backgroundColor:"white", padding:"15px", borderRadius:"20px", zIndex:"999999"}} className="banner-btn btn-anim">Book Test Drive<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                <g clip-path="url(#clip0_634_1882)">
                                  <path d="M13.6109 0H5.05533C4.84037 0 4.66643 0.173943 4.66643 0.388901C4.66643 0.603859 4.84037 0.777802 5.05533 0.777802H12.6721L0.113697 13.3362C-0.0382246 13.4881 -0.0382246 13.7342 0.113697 13.8861C0.18964 13.962 0.289171 14 0.388666 14C0.488161 14 0.587656 13.962 0.663635 13.8861L13.222 1.3277V8.94447C13.222 9.15943 13.3959 9.33337 13.6109 9.33337C13.8259 9.33337 13.9998 9.15943 13.9998 8.94447V0.388901C13.9998 0.173943 13.8258 0 13.6109 0Z" fill="#050B20"/>
                                </g>
                                <defs>
                                  <clipPath id="clip0_634_1882">
                                    <rect width="14" height="14" fill="white"/>
                                  </clipPath>
                                </defs>
                              </svg>
                            </a> */}
              </div>
            </div>
          </div>
        </section>
        {/* BANNER SECTION END */}


        {/* cars-section-three */}
        <section style={{paddingBottom:"0px"}} className="cars-section-four section-tab-car">
          <div className="boxcar-container">
            {types.length === 0  ? <div
              className="nav nav-tabs nav-car-tab"
              id="nav-tab"
              role="tablist"
            >
              <button
                className="nav-link active"
                id="suv-tab"
                data-bs-toggle="tab"
                data-bs-target="#suv"
                type="button"
                role="tab"
                aria-controls="suv"
                aria-selected="true"
              >
                {getRandomLogo()}
                <span>SUV</span>
              </button>
              <button
                className="nav-link"
                id="sedan-tab"
                data-bs-toggle="tab"
                data-bs-target="#sedan"
                type="button"
                role="tab"
                aria-controls="sedan"
                aria-selected="false"
              >
                {getRandomLogo()}
                <span>Sedan</span>
              </button>
              <button
                className="nav-link"
                id="hatchback-tab"
                data-bs-toggle="tab"
                data-bs-target="#hatchback"
                type="button"
                role="tab"
                aria-controls="hatchback"
                aria-selected="false"
              >
                {getRandomLogo()}
                <span>Hatchback</span>
              </button>
              <button
                className="nav-link"
                id="coupe-tab"
                data-bs-toggle="tab"
                data-bs-target="#coupe"
                type="button"
                role="tab"
                aria-controls="coupe"
                aria-selected="false"
              >
                {getRandomLogo()}
                <span>Coupe</span>
              </button>
              <button
                className="nav-link"
                id="hybrid-tab"
                data-bs-toggle="tab"
                data-bs-target="#hybrid"
                type="button"
                role="tab"
                aria-controls="hybrid"
                aria-selected="false"
              > 
              {getRandomLogo()}
                <span>Hybrid</span>
              </button>
            </div>:<div
              className="nav nav-tabs nav-car-tab"
              id="nav-tab"
              role="tablist"
            > {types?.map((type,index)=><button key={index}
                className={selectedType===type?`nav-link active`:`nav-link`}
                id={`${type}-tab`}
                data-bs-toggle="tab"
                data-bs-target={`#${type}`}
                type="button"
                role="tab"
                aria-controls={`${type}`}
                aria-selected="false"
                onClick={()=>setSelectedType(type)}
              > 
              {getRandomLogo(type)}
                <span>{type}</span>
              </button>)}
            </div>}

            {inventories.length === 0 ? "":<div
              className="tab-content wow fadeInUp"
              data-wow-delay="200ms"
              id="nav-tabContent"
            ><div
                className="tab-pane fade show active"
                id={selectedType}
                role="tabpanel"
                aria-labelledby={`${selectedType}-tab`}
              >
                <div className="boxcar-title">
                  <h2>The Most Searched {selectedType} Cars</h2>
                  <a href="#" className="btn-title">
                    View All
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={14}
                      height={14}
                      viewBox="0 0 14 14"
                      fill="none"
                    >
                      <g clipPath="url(#clip0_601_243)">
                        <path
                          d="M13.6109 0H5.05533C4.84037 0 4.66643 0.173943 4.66643 0.388901C4.66643 0.603859 4.84037 0.777802 5.05533 0.777802H12.6721L0.113697 13.3362C-0.0382246 13.4881 -0.0382246 13.7342 0.113697 13.8861C0.18964 13.962 0.289171 14 0.388666 14C0.488161 14 0.587656 13.962 0.663635 13.8861L13.222 1.3277V8.94447C13.222 9.15943 13.3959 9.33337 13.6109 9.33337C13.8259 9.33337 13.9998 9.15943 13.9998 8.94447V0.388901C13.9998 0.173943 13.8258 0 13.6109 0Z"
                          fill="#050B20"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_601_243">
                          <rect width={14} height={14} fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </a>
                </div>
                <div className="row">
                  {inventories.map((obj,index)=><div key={index} className="box-car car-block-four col-xl-3 col-lg-4 col-md-6 col-sm-12">
                    <div className="inner-box">
                      <div className="image-box">
                        <div className="">
                            {ProductSlider(obj.media,"modified")}
                        </div>
                        {/* <span>Low Mileage</span> */}
                        <a className="icon-box">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={12}
                            height={12}
                            viewBox="0 0 12 12"
                            fill="none"
                          >
                            <g clipPath="url(#clip0_601_1274)">
                              <path
                                d="M9.39062 12C9.15156 12 8.91671 11.9312 8.71128 11.8009L6.11794 10.1543C6.04701 10.1091 5.95296 10.1096 5.88256 10.1543L3.28869 11.8009C2.8048 12.1082 2.13755 12.0368 1.72722 11.6454C1.47556 11.4047 1.33685 11.079 1.33685 10.728V1.2704C1.33738 0.570053 1.90743 0 2.60778 0H9.39272C10.0931 0 10.6631 0.570053 10.6631 1.2704V10.728C10.6631 11.4294 10.0925 12 9.39062 12ZM6.00025 9.06935C6.24193 9.06935 6.47783 9.13765 6.68169 9.26743L9.27503 10.9135C9.31233 10.9371 9.35069 10.9487 9.39114 10.9487C9.48046 10.9487 9.61286 10.8788 9.61286 10.728V1.2704C9.61233 1.14956 9.51356 1.05079 9.39272 1.05079H2.60778C2.48642 1.05079 2.38817 1.14956 2.38817 1.2704V10.728C2.38817 10.7911 2.41023 10.8436 2.45384 10.8851C2.52582 10.9539 2.63563 10.9708 2.72599 10.9135L5.31934 9.2669C5.52267 9.13765 5.75857 9.06935 6.00025 9.06935Z"
                                fill="black"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_601_1274">
                                <rect width={12} height={12} fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </a>
                      </div>
                      <div style={{paddingLeft:"17px", paddingRight:"5px", paddingBottom:"34px"}} className="content-box">
                        <h6 className="title">
                          <a onClick={()=>handleOpen(obj)}>{obj.title}</a>
                        </h6>
                        <div className="text">
                          {obj?.carDetails?.description.slice(0,100)}
                        </div>
                       
                        <ul>
                          <li>
                            <i className="flaticon-gasoline-pump" />
                            {obj?.carDetails?.mileage} miles
                          </li>
                          <li>
                            <i className="flaticon-speedometer" />
                            {obj?.carDetails?.fuelType}
                          </li>
                          <li>
                            <i className="flaticon-gearbox" />
                            {obj?.carDetails?.transmission}
                          </li>
                        </ul>
                        
                        <div style={{position:"relative"}} className="btn-box">
                          <small style={{marginRight:"20px"}} >${obj?.price?.amount}/-</small>
                          <a style={{bottom:"0px"}}  onClick={()=>handleOpen(obj)} className="details">
                            View Details
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={14}
                              height={14}
                              viewBox="0 0 14 14"
                              fill="none"
                            >
                              <g clipPath="url(#clip0_601_4346)">
                                <path
                                  d="M13.6109 0H5.05533C4.84037 0 4.66643 0.173943 4.66643 0.388901C4.66643 0.603859 4.84037 0.777802 5.05533 0.777802H12.6721L0.113697 13.3362C-0.0382246 13.4881 -0.0382246 13.7342 0.113697 13.8861C0.18964 13.962 0.289171 14 0.388666 14C0.488161 14 0.587656 13.962 0.663635 13.8861L13.222 1.3277V8.94447C13.222 9.15943 13.3959 9.33337 13.6109 9.33337C13.8259 9.33337 13.9998 9.15943 13.9998 8.94447V0.388901C13.9998 0.173943 13.8258 0 13.6109 0Z"
                                  fill="#405FF2"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_601_4346">
                                  <rect width={14} height={14} fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </a>
                        </div>

                        <div style={{ width:"100%", display:"inline-block", height:"30px", paddingTop:"25px", padding:"20px", paddingBottom:"10px"}} >
                      <a style={{ height:"54px", textAlign:"center", width:"100%",  display:"inline-block", backgroundColor:"white", border:"1px solid #60C961", borderRadius:"20px", color:"#60C961", padding:"10px" }}   target="_blank" href={`https://wa.me/14165626307?text=${message?message:""}`} className="side-btn two">
                        Chat Via Whatsapp
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={14}
                          height={14}
                          viewBox="0 0 14 14"
                          fill="none"
                        >
                          <g clipPath="url(#clip0_881_8744)">
                            <path
                              d="M13.6111 0H5.05558C4.84062 0 4.66668 0.173943 4.66668 0.388901C4.66668 0.603859 4.84062 0.777802 5.05558 0.777802H12.6723L0.113941 13.3362C-0.0379805 13.4881 -0.0379805 13.7342 0.113941 13.8861C0.189884 13.962 0.289415 14 0.38891 14C0.488405 14 0.5879 13.962 0.663879 13.8861L13.2222 1.3277V8.94447C13.2222 9.15943 13.3962 9.33337 13.6111 9.33337C13.8261 9.33337 14 9.15943 14 8.94447V0.388901C14 0.173943 13.8261 0 13.6111 0Z"
                              fill="#60C961"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_881_8744">
                              <rect width={14} height={14} fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </a>
                    </div>
                         
                      </div>
                      
                    </div>
                  </div>)}
                </div>
              </div>
            </div>}
          </div>
        </section>
        {/* End shop section two */}
      </div>
    </div>
  );
};



function ProductSlider(arr = array, type = "default") {  
  const randomImages = type === "default" ? getRandomImages(arr,3) : getRandomImages(arr.map(obj=>{
    return obj.path
  }),15)
  return (
    <>
<Swiper
      modules={[Navigation]}
      className="slider-thumb"
       navigation={{
                                         prevEl: ".custom-prev",
                                         nextEl: ".custom-next",
                                       }}
    >
      {randomImages.map((img, index) => (
        <SwiperSlide key={index}>
          <div className="image">
            <a href="#">
              <img src={img} style={{height:"200px"}} alt="" />
            </a>
          </div>
        </SwiperSlide>
      ))}
    <button style={{position:"absolute" , top:"40%", color:"black", border:"1px solid white", backgroundColor:"#f3f3f3", opacity:"0.8" }} className="swiper-prevv custom-prev slick-arrow" aria-label="Previous">
                                                   <FaChevronLeft size={18} />
                                                 </button>
                                                 <button style={{position:"absolute" , top:"40%", color:"black", border:"1px solid white", backgroundColor:"#f3f3f3", opacity:"0.8" }} className="swiper-nextt custom-next slick-arrow" aria-label="Next">
                                                   <FaChevronRight size={18} />
                                                 </button>
    </Swiper>
    
 
    </>
    
  );
}
export default BannerSectionsecond;
